import React from 'react';
import ClientRow from './ClientRow';

const ClientTable = (props) => {
  const {
    clients,
  } = props;
  return (
    <div>
      <table className="table table-bordered" id="user_table">
        <thead>
          <tr>
            <th className="col-md-2">Client Name</th>
            <th className="col-md-2">Number Of Project</th>
            <th className="col-md-1" style={{ textAlign: 'center' }}>Total Sale</th>
          </tr>
        </thead>
        <tbody>
          {clients && clients.map((client, index) => (
            <ClientRow key={index} client={client} />
          ))}
        </tbody>
      </table>
      {clients.length > 0 ? (
        null
      ) : (
        <p style={{ textAlign: "center" }}>No Data Available</p>
      )}
    </div>
  );
};

export default ClientTable;
